import { render, staticRenderFns } from "./messagePopup.vue?vue&type=template&id=161131be"
import script from "./messagePopup.vue?vue&type=script&lang=js"
export * from "./messagePopup.vue?vue&type=script&lang=js"
import style0 from "./messagePopup.vue?vue&type=style&index=0&id=161131be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports